module.exports = __webpack_public_path__ + "static/media/delete-door.e9ac5f28.gif";